import { Controller } from "@hotwired/stimulus"

// The tiles above a section (19.10.2026): a click on a tile opens its checks
// below the row, a second click (or the cross) closes them; one panel at a time.
//
//   data-controller="tiles"
//   tile:  data-tiles-target="tile" data-key="logins" data-action="tiles#toggle"
//   panel: data-tiles-target="panel" data-key="logins" hidden
export default class extends Controller {
  static targets = ["tile", "panel"]
  // ?tile=<key>: the tile a link into this page opens (27.10.2026) -- the action plan's "Fix" and the plugin.
  static values = { open: String }

  connect() {
    if (this.openValue && this.panelTargets.some((panel) => panel.dataset.key === this.openValue)) this.show(this.openValue)
  }

  toggle(event) {
    const key = event.currentTarget.dataset.key
    const open = this.panelTargets.find((panel) => panel.dataset.key === key && !panel.hidden)
    this.show(open ? null : key)
  }

  close() { this.show(null) }

  show(key) {
    this.panelTargets.forEach((panel) => { panel.hidden = panel.dataset.key !== key })
    this.tileTargets.forEach((tile) => {
      const on = tile.dataset.key === key
      tile.classList.toggle("is-open", on)
      tile.setAttribute("aria-expanded", on ? "true" : "false")
    })
  }
}
